import calculateReferenceLine from "./calculateReferenceLine";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import Cache from "core/cache/index";
import math from "core/math";
import drawLine2 from "../../../draw/drawLine2";
import draw from "../../../draw/draw";
import toolColors from "component/toolManager/toolColors.js";
import makeKey from "core/cache/KeyGen.js";
import triggerEvent from "core/customEvent/triggerEvent";
/**
 * Renders the active reference line.
 *
 * @export @public @method
 * @name renderActiveReferenceLine
 * @param  {Object} context        The canvas context.
 * @param  {Object} eventData      The data associated with the event.
 * @param  {HTMLElement} targetElement    The element on which to render the reference line.
 * @param  {HTMLElement} referenceElement The element referenced by the line.
 * @returns {void}
 */
export default function (context, eventData, targetElement, referenceElement) {
  const targetImage = getEnabledElement(targetElement).image;
  const referenceImage = getEnabledElement(referenceElement).image;

  // Make sure the images are actually loaded for the target and reference
  if (!targetImage || !referenceImage) {
    return;
  }

  const targetSeriesKey = makeKey(
    targetImage.seriesInstanceUID,
    targetImage.modality
  );

  const referenceSeriesKey = makeKey(
    referenceImage.seriesInstanceUID,
    referenceImage.modality
  );

  let metadataCache = new Cache.Metadata();
  //const targetImagePlane = metadataCache.getImagePlaneModule(targetSeriesKey);

  const targetImagePlane = {
    imagePositionPatient: targetImage.imagePositionPatient,
    rowCosines: targetImage.rowCosines,
    columnCosines: targetImage.columnCosines,
    frameOfReferenceUID: targetImage.frameOfReferenceUID,
    rows: targetImage.rows,
    columns: targetImage.columns,
  };

  targetImagePlane.imagePositionPatient = targetImage.imagePosition;
  targetImagePlane.frameOfReferenceUID = targetImage.frameOfReferenceUID;
  targetImagePlane.rows = targetImage.rows;
  targetImagePlane.columns = targetImage.columns;

  if (
    targetImage.pixelSpacing === null ||
    targetImage.pixelSpacing === undefined
  ) {
    return;
  }

  targetImagePlane.rowPixelSpacing = targetImage.pixelSpacing[0];
  targetImagePlane.columnPixelSpacing = targetImage.pixelSpacing[1];
  // @Note MPR Reference Line 동기화를 위해 임시 수정.
  // 동기화 Reference line 정상 동작 확인 필요
  const referenceImagePlane = {
    imagePositionPatient: referenceImage.imagePosition,
    rowCosines: referenceImage.rowCosines,
    columnCosines: referenceImage.columnCosines,
    frameOfReferenceUID: referenceImage.frameOfReferenceUID,
    rows: referenceImage.rows,
    columns: referenceImage.columns,
  };
  // const referenceImagePlane = metadataCache.getImagePlaneModule(
  //   referenceSeriesKey
  // );

  if (
    referenceImage.pixelSpacing === null ||
    referenceImage.pixelSpacing === undefined
  ) {
    return;
  }

  referenceImagePlane.imagePositionPatient = referenceImage.imagePosition;
  referenceImagePlane.frameOfReferenceUID = referenceImage.frameOfReferenceUID;
  referenceImagePlane.rows = referenceImage.rows;
  referenceImagePlane.columns = referenceImage.columns;
  referenceImagePlane.rowPixelSpacing = referenceImage.pixelSpacing[0];
  referenceImagePlane.columnPixelSpacing = referenceImage.pixelSpacing[1];

  // Make sure the target and reference actually have image plane metadata
  if (
    !targetImagePlane ||
    !referenceImagePlane ||
    !targetImagePlane.rowCosines ||
    !targetImagePlane.columnCosines ||
    !targetImagePlane.imagePositionPatient ||
    !referenceImagePlane.rowCosines ||
    !referenceImagePlane.columnCosines ||
    !referenceImagePlane.imagePositionPatient
  ) {
    return;
  }

  // The image planes must be in the same frame of reference
  // if (
  //   targetImagePlane.frameOfReferenceUID !==
  //   referenceImagePlane.frameOfReferenceUID
  // ) {
  //   return;
  // }

  targetImagePlane.rowCosines = math.vector.convertToVector3(
    targetImagePlane.rowCosines
  );
  targetImagePlane.columnCosines = math.vector.convertToVector3(
    targetImagePlane.columnCosines
  );
  targetImagePlane.imagePositionPatient = math.vector.convertToVector3(
    targetImagePlane.imagePositionPatient
  );
  referenceImagePlane.rowCosines = math.vector.convertToVector3(
    referenceImagePlane.rowCosines
  );
  referenceImagePlane.columnCosines = math.vector.convertToVector3(
    referenceImagePlane.columnCosines
  );
  referenceImagePlane.imagePositionPatient = math.vector.convertToVector3(
    referenceImagePlane.imagePositionPatient
  );

  // The image plane normals must be > 30 degrees apart
  const targetNormal = targetImagePlane.rowCosines
    .clone()
    .cross(targetImagePlane.columnCosines);
  const referenceNormal = referenceImagePlane.rowCosines
    .clone()
    .cross(referenceImagePlane.columnCosines);
  let angleInRadians = targetNormal.angleTo(referenceNormal);

  angleInRadians = Math.abs(angleInRadians);
  if (angleInRadians < 0.5) {
    // 0.5 radians = ~30 degrees
    return;
  }

  const referenceLine = calculateReferenceLine(
    targetImagePlane,
    referenceImagePlane
  );

  if (!referenceLine) {
    return;
  }
  //const color = toolColors.getActiveColor();
  const color = "#00ff00";

  // Draw the referenceLines
  // 동기화시, 다수의 동일한 시리즈 영상간 동기화를 고려해야한다면, 아래코드를 사용하면안됨
  // (아래 코드는 변형 모델을 초기화 함)
  //context.setTransform(1, 0, 0, 1, 0, 0);
  let eventDataElementStub = getEnabledElement(eventData.element);
  eventDataElementStub.needsRedraw = true;

  draw(context, (context) => {
    let eventDataElementStub = getEnabledElement(eventData.element);
    eventDataElementStub.needsRedraw = true;
    triggerEvent(eventDataElementStub.element, "setState", []);
    //console.log(new Error().stack);
    drawLine2(
      context,
      eventData.element,
      referenceLine.start,
      referenceLine.end,
      { color },
      "pixel"
    );
  });
}
